import { useMemo } from 'react';
import { useMatches } from 'react-router';
// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';

const schema = z.object({
  maxWidthAndCenteredLayoutContent: z.boolean(),
});

export function useMaxWidthAndCenteredLayoutContent() {
  const matches = useMatches();

  const maxWidthAndCenteredLayoutContent = useMemo(() => {
    const reversedMatches = [...matches].reverse();

    for (const match of reversedMatches) {
      const parse = schema.safeParse(match.handle);
      if (parse.success) {
        return parse.data.maxWidthAndCenteredLayoutContent;
      }
    }
    return undefined;
  }, [matches]);

  return maxWidthAndCenteredLayoutContent;
}
